import FacebookIcon from "../assets/social/Facebook.svg";
import InstagramIcon from "../assets/social/Instagram.svg";
import LinkedinIcon from "../assets/social/linkdein.svg";
import YoutubeIcon from "../assets/social/youtube.svg";
export const SocialIcons = {
  facebook: {
    icon: FacebookIcon,
    href: "https://www.facebook.com/mastersvisa2",
  },
  instagram: {
    icon: InstagramIcon,
    href: "https://www.instagram.com/mastersvisa/",
  },
  linkedin: {
    icon: LinkedinIcon,
    href: "https://www.linkedin.com/company/mastersvisa/",
  },
  youtube: {
    icon: YoutubeIcon,
    href: "https://youtube.com/@MastersVisa",
  },
};
